import {TicketReadyToUseResultVo} from '../../common/shared/api/nicolas/vo/TicketReadyToUseResultVo.interface';
import {LegacySingle, ReadyToUseTicket} from '../generated/types';
import {createReadAccessType} from './ReadAccessType';
import {createSaleMethod} from './SaleMethod';
import {createTicketInfo} from './TicketInfo';
import {createTicketType} from './TicketType';

export function createReadyToUseTicket({
  result: {series, single, my, available, purchase, rental_period_by_minute},
  nextItem,
}: {
  result: TicketReadyToUseResultVo;
  nextItem?: LegacySingle;
}): ReadyToUseTicket {
  return {
    nextItem, // '이전화, 다음화' 선택 팝업이 떴을 때 다음화 부분을 가져오기 위한 부분
    series: {
      isWaitfree: series.is_waitfree,
      waitfreeBlockCount: series.waitfree_block_count,
      saleMethod: createSaleMethod(series.sale_method),
    },
    single: {
      title: single.title,
      readAccessType: createReadAccessType(single.read_access_type),
      waitfreeBlock: single.waitfree_block,
      isDone: single.is_done,
    },
    my: my && {
      ticketOwnCount: my.ticket_own_count,
      ticketRentalCount: my.ticket_rental_count,
      cashAmount: my.cash_amount,
    },
    available: available && {
      ...(available.ticket_own_type && {
        ticketOwnType: createTicketType(available.ticket_own_type),
      }),
      ...(available.ticket_rental_type && {
        ticketRentalType: createTicketType(available.ticket_rental_type),
      }),
    },
    purchase: purchase && {
      ...(purchase.ticket_own && {
        ticketOwn: createTicketInfo(purchase.ticket_own),
      }),
      ...(purchase.ticket_rental && {
        ticketRental: createTicketInfo(purchase.ticket_rental),
      }),
      ...(purchase.set && {
        set: {
          setId: purchase.set.set_id,
          discountRate: purchase.set.discount_rate,
          isMultiple: purchase.set.is_multiple,
        },
      }),
    },
    rentalPeriodByMinute: rental_period_by_minute,
  };
}
